import { memo } from 'react';

import { Toast } from '@/molecules';

import { useToast } from '@/lib/hooks';

import type { FunctionComponent } from 'react';
import type { TypeToastCenterProps } from './types';

/**
 * ToastCenter
 */
export const ToastCenter: FunctionComponent<TypeToastCenterProps> = ({
  className,
  style = {
    position: 'absolute',
    zIndex: -10,
    width: '100%',
    inset: 'auto',
  },
  children,
}: TypeToastCenterProps) => {
  const toast = useToast();

  return (
    <div {...(className && { className })} style={style}>
      {toast.map((t) => (
        <div
          key={t.id}
          style={{
            display: 'flex',
            position: 'absolute',
            transition: 'all 230ms cubic-bezier(0.21, 1.02, 0.73, 1) 0s',
            zIndex: t.visible ? 10 : -10,
            width: '100%',
            justifyContent: 'center',
          }}
        >
          {children ? (
            children(t)
          ) : (
            <Toast
              {...t}
              className={`${
                t.visible ? 'animate-toast-out' : 'animate-toast-in'
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default memo(ToastCenter);
